import React from "react";

const profileEntry = ({ heading, value }) => {
  return (
    <h5 style={styles.profile}>
      <p style={styles.headingStyle}>{heading}</p>
      <p style={styles.valueStyle}>{value}</p>
    </h5>
  );
};

const styles = {
  profile: {
    display: "flex",
    width: "100%",
    marginBottom: 5,
    padding: 5,
    backgroundColor: "#eee",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },
  headingStyle: {
    width: "50%",
    fontSize: 20
  },
  valueStyle: {
    width: "50%"
  }
};

export default profileEntry;
